import { render, staticRenderFns } from "./extraDetails.vue?vue&type=template&id=2c595dc6&"
import script from "./extraDetails.vue?vue&type=script&lang=js&"
export * from "./extraDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports